export { IfBrowser } from './lib/if-browser';
export { isBrowser } from './lib/is-browser';
